import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, FormField } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const MedindehaverDetailsStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [errors, setErrors] = useState<{ name?: string; email?: string }>({});
  const [intro, setIntro] = useState<string>('Vi sender samtykke til medindehaveren. Udfyld nedenfor.');

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.medindehaver_details).then(c => {
      if (c?.body && c.body.length > 0) {setIntro(c.body[0]);}
    });
  }, []);

  const validate = () => {
    const e: { name?: string; email?: string } = {};
    if (!selfServiceData.medindehaverName?.trim()) {e.name = 'Angiv navn.';}
    if (!selfServiceData.medindehaverEmail?.trim()) {e.email = 'Angiv email.';}
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selfServiceData.medindehaverEmail)) {e.email = 'Ugyldig email.';}
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onNext = () => {
    if (validate()) {goNext();}
  };

  return (
    <StepContainer title="Medindehaver">
      <p>{intro}</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <FormField name="medindehaverName" value={selfServiceData.medindehaverName || ''} placeholder="Navn" error={errors.name} onChange={(e) => updateSelfServiceData('medindehaverName', e.target.value)} />
        <FormField type="email" name="medindehaverEmail" value={selfServiceData.medindehaverEmail || ''} placeholder="Email" error={errors.email} onChange={(e) => updateSelfServiceData('medindehaverEmail', e.target.value)} />
      </div>
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default MedindehaverDetailsStep;
